import React, { useEffect, useState } from 'react';
import {
  Card,
  Typography,
  Collapse,
  IconButton,
} from '@one-thd/sui-atomic-components';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';
import { ReorderRecommendations } from '@thd-olt-component-react/thd-recs-containers';

const REORDER_RECOMMENDATIONS_REQUEST_KEY = 'purchase-history';

export const ReorderRecommendationsSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  // ReorderRecommendations relies on store-localization state (useStore) that
  // isn't guaranteed to match between SSR and the first client render, so the
  // whole card is deferred until after mount rather than hydration-mismatching.
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <div className="sui-w-full">
      <Card
        initialSize="full"
        className="!sui-rounded-[6px] sui-flex sui-h-full"
      >
        <div className="sui-flex sui-flex-col sui-w-full">
          <div className="sui-relative sui-flex sui-items-center">
            <Typography
              variant="h3"
              className={isExpanded ? undefined : 'sui-w-full sui-text-center'}
            >
              Buy It Again
            </Typography>
            <div className="sui-absolute sui-right-0 sui-top-1/2 sui--translate-y-1/2">
              <IconButton
                onClick={() => setIsExpanded((prev) => !prev)}
                icon={isExpanded ? ArrowUp : ArrowDown}
                aria-label={
                  isExpanded ? 'Collapse Buy It Again' : 'Expand Buy It Again'
                }
                data-testid="buy-it-again-toggle"
              />
            </div>
          </div>
          <Collapse in={isExpanded}>
            <div className="sui-mt-4">
              <ReorderRecommendations
                requestKey={REORDER_RECOMMENDATIONS_REQUEST_KEY}
                hideTitle
                showLoading
                showFallback
              />
            </div>
          </Collapse>
        </div>
      </Card>
    </div>
  );
};

ReorderRecommendationsSection.dataModel = ReorderRecommendations.dataModel;
